import { render, staticRenderFns } from "./ServerConfiguration.vue?vue&type=template&id=5fb327c9"
import script from "./ServerConfiguration.vue?vue&type=script&lang=js"
export * from "./ServerConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports